import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import AdView from '../Shared/AdView/AdView';
import AdListMobile from './ListView/ListView';

const VisibilityWrapper = styled.div<{ $visible: boolean }>`
  display: ${(p) => (p.$visible ? 'initial' : 'none')};
`;

function TearsheetMobileView() {
  const store_tearsheet = store.tearsheet;
  if (!store_tearsheet) return <></>;

  const store_router = store.router;

  const params = store_router.params;
  const isViewMode = !!(params && params.adIndex); // otherwise list mode

  return (
    <>
      <VisibilityWrapper $visible={!isViewMode}>
        <AdListMobile />
      </VisibilityWrapper>

      <VisibilityWrapper $visible={isViewMode}>
        <AdView variant="mobile" />
      </VisibilityWrapper>
    </>
  );
}

export default observer(TearsheetMobileView);
